import { useMemo } from 'react'
import { useAuth } from 'torqcloud-ui'

import { useOrganization } from '@/contexts/OrganizationContext'
import { canViewOrganizationUsage } from '@/utils/organizationUsageAccess'

export default function useOrganizationUsageAccess() {
  const { organizations } = useAuth()
  const { currentOrganizationId } = useOrganization()

  return useMemo(() => {
    const currentOrganization = organizations.find(organization => organization.organization_id === currentOrganizationId) ?? null
    return { canViewOrganizationUsage: canViewOrganizationUsage(currentOrganization) }
  }, [currentOrganizationId, organizations])
}
